module.exports = __webpack_public_path__ + "2eb1ea528fdee701b679ef94bb660b1f.otf";